'use client'

import { useState } from 'react'
import { redirect } from 'next/navigation'
import { IMAGE_DIR } from '@/shared/constants/linksApi.js'

export const News = ({ newsData }) => {
    const navigate = (path) => redirect(path)

    const [initialCountNews, setInitialCountNews] = useState(7)
    const limitNews = initialCountNews >= newsData.length

    return (
        <div className={'News'}>
            {newsData?.slice(0, initialCountNews).map((item, index) => {
                const cuteTitle = item.title.replaceAll('&quot;', '')
                const imageLink = item.image
                    ? IMAGE_DIR + item.image
                    : '/bg/stub-pictures-news.png'
                return (
                    <div
                        onClick={() => navigate('/' + item.url)}
                        key={index}
                        className={'item-card'}
                    >
                        <img
                            src={imageLink}
                            alt="image"
                            onError={(e) =>
                                (e.target.src = '/bg/stub-pictures-news.png')
                            }
                        />
                        <div className={'item-card_text'}>
                            <h3>{cuteTitle}</h3>
                            <p>{item.description}</p>
                        </div>
                    </div>
                )
            })}
            {!limitNews && (
                <div className={'action'}>
                    <button
                        onClick={() =>
                            setInitialCountNews((state) => state + 7)
                        }
                    >
                        <img
                            src="/icons/showMore.svg"
                            alt="Иконка загрузки новых новостей"
                        />
                        <span>Показать ещё</span>
                    </button>
                </div>
            )}
        </div>
    )
}
